export default "__VITE_ASSET__B0Ks5kp5__"